import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SloganMarquee } from "@/components/SloganMarquee";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";

export default function LandingPage() {
  return (
    <div className="bg-navy-950 min-h-screen" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <SloganMarquee />
        <Services />
        <About />
        <Gallery />
        <Contact />
      </main>
    </div>
  );
}
